import React from 'react';

export const TYPE_CONFIG: Record<string, { label: string; bg: string; text: string }> = {
  single_choice: { label: 'Single Choice', bg: 'bg-blue-100', text: 'text-blue-700' },
  multiple_choice: { label: 'Multi Choice', bg: 'bg-indigo-100', text: 'text-indigo-700' },
  yes_no: { label: 'Yes / No', bg: 'bg-sky-100', text: 'text-sky-700' },
  rating_scale: { label: 'Rating Scale', bg: 'bg-purple-100', text: 'text-purple-700' },
  likert_scale: { label: 'Likert Scale', bg: 'bg-violet-100', text: 'text-violet-700' },
  ranking: { label: 'Ranking', bg: 'bg-fuchsia-100', text: 'text-fuchsia-700' },
  short_text: { label: 'Short Text', bg: 'bg-emerald-100', text: 'text-emerald-700' },
  long_text: { label: 'Long Text', bg: 'bg-green-100', text: 'text-green-700' },
  dropdown: { label: 'Dropdown', bg: 'bg-teal-100', text: 'text-teal-700' },
  nps: { label: 'NPS', bg: 'bg-orange-100', text: 'text-orange-700' },
  numeric_input: { label: 'Numeric', bg: 'bg-amber-100', text: 'text-amber-700' },
  slider_scale: { label: 'Slider', bg: 'bg-amber-100', text: 'text-amber-700' },
  max_diff: { label: 'MaxDiff', bg: 'bg-rose-100', text: 'text-rose-700' },
  conjoint_analysis: { label: 'Conjoint', bg: 'bg-pink-100', text: 'text-pink-700' },
  info_screen: { label: 'Info Screen', bg: 'bg-gray-100', text: 'text-gray-600' },
  eyetracking_study: { label: 'Eye-tracking Study', bg: 'bg-violet-100', text: 'text-violet-700' },
  image_hotspot: { label: 'Image Hotspot', bg: 'bg-cyan-100', text: 'text-cyan-700' },
  matrix_rating: { label: 'Matrix Rating', bg: 'bg-lime-100', text: 'text-lime-700' },
  matrix_grid: { label: 'Matrix Grid', bg: 'bg-lime-100', text: 'text-lime-700' },
};

interface QuestionTypeTagProps {
  type: string;
  loading?: boolean;
}

const QuestionTypeTag: React.FC<QuestionTypeTagProps> = ({ type, loading }) => {
  if (loading) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-400 animate-pulse">
        detecting...
      </span>
    );
  }

  if (!type) return null;

  const cfg = TYPE_CONFIG[type] || { label: type, bg: 'bg-gray-100', text: 'text-gray-600' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold tracking-wide ${cfg.bg} ${cfg.text}`}
    >
      {cfg.label}
    </span>
  );
};

export default QuestionTypeTag;
